import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from './icons';

const iconMap = Object.values(Icons).reduce((map, icon) => {
  map[icon.iconName] = icon;
  return map;
}, {});

const DoctypeIcon = React.forwardRef(({ type, size = 24, thumbnail, ...props }, ref) => {
  const key = thumbnail ? `${type}-thumbnail` : type;
  const Icon = iconMap[key];
  if (!Icon) return null;

  return <Icon ref={ref} width={size} height={size} {...props} />;
});

DoctypeIcon.displayName = 'DoctypeIcon';

DoctypeIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thumbnail: PropTypes.bool
};

export default DoctypeIcon;
